import React from 'react'
import NotFoundApp from "../../features/notfound/NotFound"
export default function NotFound() {
  return (<NotFoundApp/>)
}
